module.exports = __webpack_public_path__ + "img/login-v2-dark.751cb0f5.svg";